var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3165 1.36698H2.1055C0.942664 1.36698 0 2.30965 0 3.47249V11.8945C0 13.0573 0.942665 14 2.1055 14H10.5275C11.6903 14 12.633 13.0573 12.633 11.8945V7.68349H11.5802V11.8945C11.5802 12.4759 11.1089 12.9472 10.5275 12.9472H2.1055C1.52408 12.9472 1.05275 12.4759 1.05275 11.8945V3.47249C1.05275 2.89107 1.52408 2.41973 2.1055 2.41973H6.3165V1.36698Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4778 0C13.7662 -6.22545e-08 14 0.23381 14 0.522229L14 5.22229C14 5.51071 13.7662 5.74452 13.4778 5.74452C13.1894 5.74452 12.9555 5.51071 12.9555 5.22229V1.783L6.83089 7.90766C6.62695 8.1116 6.29629 8.1116 6.09235 7.90766C5.88841 7.70372 5.88841 7.37306 6.09235 7.16912L12.217 1.04446L8.77772 1.04446C8.4893 1.04446 8.25549 0.810649 8.25549 0.522229C8.25549 0.233811 8.4893 8.71563e-07 8.77772 8.40436e-07L13.4778 0Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external-link-icon.857c7d01c1eda6e707ab00adb3a8d8ba.svg";
export { ForwardRef as ReactComponent };